import { render, staticRenderFns } from "./NewShopNoWebhookChat.vue?vue&type=template&id=c4a7cb08&"
import script from "./NewShopNoWebhookChat.vue?vue&type=script&lang=js&"
export * from "./NewShopNoWebhookChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports